// material
import { Container } from '@mui/material';

// components
import PageHeader from '../components/smallComponents/PageHeader';
import Page from '../components/Page';
import Projects from '../components/Projects';

export default function ProjectsWithAssessmentStatus() {
  const approved = "false";
  return (
    <Page title="Projects">
      <Container maxWidth="xl">
        <PageHeader title="Projects" />
        <Projects approved={approved} />
      </Container>
    </Page>
  );
}
 